/**
 * A monitor's latest readings, grouped (System / Printer / Supplies / Power / Network…), one card a
 * group. Shared by the monitor page and the device page's SNMP tab so the two read alike.
 *
 * Rebuilt wholesale rather than diffed: these are label/value pairs that all change together on every
 * poll, so there is no row worth keeping - the opposite of the case `CardList` exists for.
 */
import type { StackPanel } from 'webwin';
import type { SnmpMetric } from '../../contracts.gen.js';
import { card, fillWith, FONT, GAP, h2, hstack, muted, splitRow, stackOf, value, vstack } from '../../ui/layout.js';

export function fillMetricGroups(host: StackPanel, metrics: readonly SnmpMetric[]): void {
  host.controls.clear();
  const groups = new Map<string, SnmpMetric[]>();
  for (const metric of metrics) {
    const name = metric.group || 'General';
    const existing = groups.get(name);
    if (existing) existing.push(metric);
    else groups.set(name, [metric]);
  }

  for (const [name, rows] of groups) {
    const body = vstack({ spacing: GAP.xs, hAlign: 'stretch', autoWidth: false });
    for (const metric of rows) {
      const row = splitRow({ align: 'center' });
      fillWith(row, muted(metric.name));
      row.controls.add(
        stackOf(hstack({ spacing: GAP.xs, autoWidth: true }), value(metric.value, { font: FONT.bold }), muted(metric.unit))
      );
      body.controls.add(row);
    }
    const group = card();
    group.controls.add(stackOf(vstack({ spacing: GAP.sm, hAlign: 'stretch', autoWidth: false }), h2(name), body));
    host.controls.add(group);
  }
}
